import React, { useState, useEffect } from "react";
import axios from "../api/axios";
import { useLocation } from "react-router-dom";
import ProductCard from "./ProductCard";

export default function ProductList({ 
  setProductCount, 
  selectedCategories = [], 
  maxPrice = 20000, 
  sortBy = "",
  searchQuery = ""
}) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);

    const hasActiveFilters = selectedCategories.length > 0 || maxPrice < 20000 || sortBy !== "" || searchQuery !== "";

    let endpoint = '/products';
    if (hasActiveFilters) {
      const params = new URLSearchParams();
      if (selectedCategories.length > 0) {
        params.append('categories', selectedCategories.join(','));
      }
      params.append('min', 0);
      params.append('max', maxPrice);
      if (sortBy) {
        params.append('sort_key', sortBy);
      }
      if (searchQuery) {
        params.append('name', searchQuery);
      }
      endpoint = `/products/search?${params.toString()}`;
    } else {
      const searchParams = new URLSearchParams(location.search);
      const categorySlug = searchParams.get('category');
      if (categorySlug) {
        endpoint = `/products/category/${categorySlug}`;
      }
    }

    axios.get(endpoint)
      .then(response => {
        if (response.data && response.data.data) {
          setProducts(response.data.data);
          if (setProductCount) setProductCount(response.data.data.length);
        } else {
          setProducts([]);
          if (setProductCount) setProductCount(0);
        }
      })
      .catch(error => {
        console.error("Error fetching products:", error);
        setProducts([]);
        if (setProductCount) setProductCount(0);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [location.search, selectedCategories, maxPrice, sortBy, searchQuery, setProductCount]);

  return (
    <div className="category_outer_main">
      <div className="container-fluid">
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-dark" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="row g-2">
            {products.length > 0 ? (
              products.map((item) => (
                <div className="col-lg-3 col-md-3 col-sm-6 col-6" key={item.id}>
                  <ProductCard product={item} />
                </div>
              ))
            ) : (
              <div className="col-12 text-center py-5">
                <h4>No products found for this category.</h4>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

